import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function Corporate(props) {
    return (
        <SvgIcon viewBox="0 0 56 56" {...props} >
            <circle cx="28" cy="28" r="28" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.9999 19.6667H44.6666V43H11.3333V13H27.9999V19.6667ZM14.6666 39.6667H17.9999V36.3333H14.6666V39.6667ZM17.9999 33H14.6666V29.6667H17.9999V33ZM14.6666 26.3333H17.9999V23H14.6666V26.3333ZM17.9999 19.6667H14.6666V16.3333H17.9999V19.6667ZM21.3333 39.6667H24.6666V36.3333H21.3333V39.6667ZM24.6666 33H21.3333V29.6667H24.6666V33ZM21.3333 26.3333H24.6666V23H21.3333V26.3333ZM24.6666 19.6667H21.3333V16.3333H24.6666V19.6667ZM27.9999 39.6667H41.3333V23H27.9999V26.3333H31.3333V29.6667H27.9999V33H31.3333V36.3333H27.9999V39.6667ZM37.9999 26.3333H34.6666V29.6667H37.9999V26.3333ZM34.6666 33H37.9999V36.3333H34.6666V33Z" fill="black"/>
        </SvgIcon>
    );
}